import React from "react";
import { useRecoilValue } from "recoil";
import VIPMediumCard from "../../../../../components/VIPMediumCard";
import { accountAtom } from "../../../../Login/atoms/AccountAtom";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../../PermissionsConstants";
import { useGetInvoices } from "../../InvoiceCapture/hooks/useGetInvoices";
interface Props {}
export const InvoicesCard: React.FC<Props> = () => {
  const { data: invoiceData } = useGetInvoices();
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_vendorinvoice_add;
  const user = useRecoilValue(accountAtom);

  return (
    <>
      <VIPMediumCard
        title={"Invoices"}
        showPlustButton={userPermissions.includes(addPermission) ? true : false}
        cardRowName1={"Unsubmitted Invoices"}
        cardRowCount1={
          invoiceData?.data
            ?.map((data) => ({ ...data }))
            .filter(
              (x) => x.status === "Unverified" || x.status === "For Review"
            ).length
        }
        cardRowName2={"All My Invoices"}
        cardRowCount2={
          invoiceData?.data
            ?.filter(
              (c) =>
                user.userName.includes(c.createdBy) ||
                user.userName.includes(c.modifiedBy)
            )
            .map((x) => ({ ...x })).length
        }
        cardRowName3={""}
        cardRowCount3={""}
        className={""}
      />
    </>
  );
};
